import { User } from "../@types/user"

export const getUserPlatform = (user: User) => {
  if(user.env.isMobileWeb) {
    return 'mobile'
  }

  if(user.env.isApp) {
    return 'app'
  }

  if(user.env.isDesktop) {
    return 'desktop'
  }

  return 'unableToDetermineUserPlatform'
}